// IE 2026 09 28 / ODOO-342342: «Бизнес-кейсы» — форма-меню кейсов (вкладка Contents формы USE-CASE, компонент AttrUseCaseMenu над MenuPanel inline).
// Строки — _doc.items_view бэка (контракт v1 §4.1; совместимы с tasksPanel_flatten: node / attrs / status) → пункты MenuPanel:
//   - группы (колонки с заголовком): этап пути (kind stage, node AttrTab) и раздел каталога (kind section) — у карты кейсов (uc-root) и раздела;
//     заголовок раздела — ссылка (открыть карточку раздела), этапа — нет; вложенный раздел / этап — своей группой следом (как чистые папки tasksPanel);
//   - пункты: кейс, путь, якорь (TEST-DATA), страница, виджет, раздел инструкции (docs); пункты вне групп — в общую группу runsTitle панели;
//   - номер шага пути — n (только у играбельных листьев), минуты — приписка «3 min», бейдж — статус готовности (status_title + cssClass-status строки,
//     иначе элемент словаря STATUS), вторая пилюля — «Demo check failed» (check_status = uc-status-check-failed), подсказка — summary / note;
//   - «скоро» (soon: Planned / Idea — приходят только тем, кому бэк их отдаёт, К5): пункт со статусом, без ▶; клик — карточка;
//   - ▶ «Open in demo» — у играбельных (playable) и не «скоро»; ✓ «пройдено» и звезда — у кейсов и путей (личные отметки, utils/guidePersonal.js).
// Клик (useCaseMenu_action): кейс / путь / раздел — карточка записи; якорь / страница / виджет — «Open in demo» этой строки; docs — читалка инструкции.
import { guideCases_count, guideCases_now } from './guideCases.js'

export const CHECK_FAILED = 'uc-status-check-failed'
// цвета статусов STATUS-use-case (контракт v1 §3) — запасной путь, когда ни строка (cssClass-status), ни словарь STATUS цвета не дали (шаги пути в ответе play_plan)
export const UC_STATUS_CSS = {
    'uc-status-live': 'cell-background-green', 'uc-status-partial': 'cell-background-yellow', 'uc-status-data': 'cell-background-blue',
    'uc-status-planned': 'cell-background-grey', [CHECK_FAILED]: 'cell-background-red',
}
export const KIND_ICON = {
    section: 'pi pi-folder', stage: 'pi pi-flag', case: 'pi pi-bookmark', path: 'pi pi-directions',
    anchor: 'pi pi-desktop', page: 'pi pi-file', widget: 'pi pi-table', docs: 'pi pi-book', link: 'pi pi-link', text: 'pi pi-minus',
}
const GROUP_KINDS = new Set(['stage', 'section'])
const RECORD_KINDS = new Set(['section', 'case', 'path'])          // пункт — запись USE-CASE (карточка, звезда, ✓)
const STEP_KINDS = new Set(['case', 'anchor', 'page', 'widget'])  // играбельные листья (номер шага пути)

const isObj = (x) => !!(x && typeof x === 'object')
const str = (v) => (v === undefined || v === null) ? '' : String(v)
const identityT = (text, params) => String(text || '').replace(/\{(\w+)\}/g, (m, k) => (params && k in params) ? String(params[k]) : m)
const withPi = (pi) => { const s = str(pi).trim().replace(/^pi\s+/, ''); return s ? 'pi ' + s : '' }

// id записи строки — node.value
export function ucRow_id(r) { return isObj(r) && isObj(r.node) ? str(r.node.value) : '' }

// вид строки: поле kind бэка, иначе — по узлу (строки без kind: prior-бэк / ручные)
export function ucRow_kind(r) {
    if (!isObj(r)) return ''
    const k = str(r.kind).trim()
    if (k) return k
    const n = isObj(r.node) ? r.node : {}
    const seg = str(n.relation_segment), v = str(n.value)
    if (n.attr_type === 'AttrTab') return 'stage'
    if (v.startsWith('docs:')) return 'docs'
    if (seg === 'USE-CASE') return 'case'
    if (seg === 'TEST-DATA') return 'anchor'
    if (seg === 'PAGE') return 'page'
    if (seg.startsWith('WIDGET-')) return 'widget'
    return ''
}

// раздел инструкции: путь без схемы docs: (как хранит doc.doc_link и шлёт docsNav)
export function ucRow_docsLink(r) {
    const v = isObj(r) && isObj(r.node) ? str(r.node.value).trim() : ''
    if (!v) return ''
    return v.startsWith('docs:') ? v.slice(5).trim() : (ucRow_kind(r) === 'docs' ? v : '')
}

export function ucRow_minutes(r) {
    const m = isObj(r) ? Number(r.minutes) : NaN
    return Number.isFinite(m) && m > 0 ? m : null
}
export function useCaseMenu_minutesText(n, t = identityT) {
    const m = Number(n)
    if (!Number.isFinite(m) || m <= 0) return ''
    return t('{n} min', { n: Math.round(m * 10) / 10 })
}

// бейдж статуса готовности: название и цвет из строки (status_title / cssClass-status — бэк кладёт явно), иначе элемент словаря STATUS
export function ucRow_status(r, ctx = {}) {
    const id = isObj(r) ? str(r.status).trim() : ''
    if (!id) return null
    const dictRow = typeof ctx.dictRow === 'function' ? ctx.dictRow : () => null
    let item = null
    try { item = dictRow('STATUS', id) } catch (e) { item = null }
    const text = str(r.status_title).trim() || str(item?.title || item?.doc?.title).trim() || id.replace(/^uc-status-/, '').replace(/^STATUS-/, '').replace(/^\w/, c => c.toUpperCase())
    const cls = str(r['cssClass-status']).trim() || str(item?.cssClass || item?.doc?.cssClass).trim() || UC_STATUS_CSS[id] || ''
    const note = str(r.status_note || r.note).trim()
    const b = { text, cls, title: [text, note].filter(Boolean).join(' · '), id }
    const alt = Array.isArray(item?.titles_alt) ? [...new Set(item.titles_alt.map(v => str(v).trim()).filter(v => v && v !== text))] : []
    if (alt.length) b.alt = alt   // поиск панели по имени статуса на другом языке (как у панели задач)
    return b
}

// «Demo check failed» — системная отметка проверки якорей (doc.check_status / строка check_status); в подсказке — сколько якорей не прошло
// IE 2026 09 28 / ODOO-342342 (контракт v1.2 §7): не прошёл — и отличие от эталона (diff), и ошибка прогона (error: напр. недостающая витрина — «mart … is missing:
// a read-only run … does not build marts»), и якорь, которого нет (missing): в подсказке — «не прошли проверку», а не «отличаются от эталона». Тому, кто может принять
// эталон (rights.edit, ctx.showUnit), у строки якоря — итог и причина из _doc.check.anchors (ctx.anchorCheck: id → {status, summary})
const CHECK_STATUS_TEXT = { diff: 'Differs from the reference', error: 'Check error', missing: 'The demo view is not found' }
export function ucRow_checkBadge(r, ctx = {}) {
    if (!isObj(r) || str(r.check_status) !== CHECK_FAILED) return null
    const t = typeof ctx.t === 'function' ? ctx.t : identityT
    const c = isObj(r.check) ? r.check : {}
    const failed = Number(c.failed) || 0, total = Number(c.total) || 0
    const text = t('Demo check failed')
    const parts = [text]
    const a = (ctx.showUnit && ctx.anchorCheck && typeof ctx.anchorCheck.get === 'function' && ucRow_kind(r) === 'anchor') ? ctx.anchorCheck.get(ucRow_id(r)) : null
    if (a && (CHECK_STATUS_TEXT[a.status] || a.summary)) {
        if (CHECK_STATUS_TEXT[a.status]) parts.push(t(CHECK_STATUS_TEXT[a.status]))
        if (str(a.summary).trim()) parts.push(str(a.summary).trim())
    } else if (total) parts.push(t('{failed} of {total} demo views failed the check', { failed, total }))
    return { text, cls: 'cell-background-red', title: parts.join(' · '), id: CHECK_FAILED }
}

// IE 2026 09 28 / ODOO-342342 (контракт v1.1 §7): итог ночной проверки якоря «unit» — эталон снят до смены единицы длительностей базы (дни ↔ секунды), отличие
// только в ×86 400 у полей DOS: вид демо не сломан, эталон надо принять заново. Не провал («Demo check failed» его не считает); администратору (rights.edit
// формы) — серая пилюля у такого якоря, остальным — ничего. ctx.unitIds — id якорей со статусом unit (_doc.check.anchors формы), ctx.showUnit — показывать ли
export const UNIT_SWITCH = 'unit'
export function ucRow_unitBadge(r, ctx = {}) {
    if (!ctx.showUnit || !ctx.unitIds || typeof ctx.unitIds.has !== 'function') return null
    const id = ucRow_id(r)
    if (!id || ucRow_kind(r) !== 'anchor' || !ctx.unitIds.has(id)) return null
    const t = typeof ctx.t === 'function' ? ctx.t : identityT
    return { text: t('Reference before the unit change'), cls: 'cell-background-grey', id: UNIT_SWITCH,
        title: t('The reference of this demo view predates the duration unit change of the database (days ↔ seconds): accept the reference again. The demo view itself is not broken') }
}

// данные строки для клика и пометок (пункт MenuPanel несёт их в _uc)
export function ucRow_info(r, ctx = {}) {
    const kind = ucRow_kind(r)
    const id = str(r?.id) || ucRow_id(r)   // у группы-раздела карты кейсов бэк кладёт id записи рядом с узлом AttrTab
    const n = Number(r?.n)
    const missing = !!r?.missing
    let playable = !!r?.playable && !r?.soon && !missing
    // страница / виджет в карточке КЕЙСА: play_plan кейса выбирает первый якорь, а без якорей — первую страницу / виджет (бэк guide.play_plan); отдельную строку
    // выбрать нельзя (дыра контракта v1) — ▶ только у той строки, которую бэк и откроет, у остальных нет, чтобы не открыть не то
    if (playable && (kind === 'page' || kind === 'widget') && ctx.cardKind === 'case' && ctx._caseLinks) playable = ctx._caseLinks.target === r
    return {
        id, kind,
        segment: isObj(r?.node) ? str(r.node.relation_segment) : '',
        title: isObj(r?.node) ? str(r.node.valueStr || r.node.value) : '',
        n: Number.isFinite(n) && n > 0 ? n : null,
        playable,
        soon: !!r?.soon,
        missing,
        anchor: str(r?.anchor) || (kind === 'anchor' ? id : ''),
        docs: kind === 'docs' ? ucRow_docsLink(r) : '',
        record: RECORD_KINDS.has(kind) && !!id && !missing,
        card: { id: str(ctx.cardId), kind: str(ctx.cardKind) },   // запись формы, в которой стоит меню (play_plan: id / step / anchor)
    }
}

// карточка кейса: какую строку-ссылку (страница / виджет) откроет play_plan кейса — первую, если у кейса нет играбельных якорей
export function useCaseMenu_caseLinks(rows) {
    let anchor = false, target = null
    useCaseMenu_walk(rows, (r) => {
        const k = ucRow_kind(r)
        if (k === 'anchor' && r.playable) anchor = true
        if (!target && (k === 'page' || k === 'widget')) target = r
    })
    return { anchor, target: anchor ? null : target }
}

// пункт MenuPanel из строки (рекурсивно — дети строки, например якоря кейса внутри пути)
export function useCaseMenu_item(r, ctx = {}, depthPath = []) {
    const t = typeof ctx.t === 'function' ? ctx.t : identityT
    const info = ucRow_info(r, ctx)
    const title = info.title || t('(untitled)')
    const it = {
        title,
        cssClass: withPi(r?.node?.pi) || KIND_ICON[info.kind] || 'pi pi-circle',
        _uc: info,
        _row: r,
    }
    if (info.n != null && ctx.numbers !== false) it.num = info.n
    const st = ucRow_status(r, ctx)
    if (st) it.badge = st
    const chk = ucRow_checkBadge(r, ctx)
    const unit = ucRow_unitBadge(r, ctx)
    if (chk || unit) it.badges2 = [chk, unit].filter(Boolean)
    const min = ucRow_minutes(r)
    if (min != null) it.aside = useCaseMenu_minutesText(min, t)
    const tip = [str(r?.summary).trim(), str(r?.note).trim()].filter(Boolean)
    if (info.soon) tip.unshift(t('Coming soon: not in the demo yet'))
    if (info.missing) tip.unshift(t('This record is missing in the database'))
    if (tip.length) it.tooltip = tip.join(' · ')
    // ссылка (MenuPanel: isAction) — у записи, играбельного шага и раздела инструкции; команда — только для подсказки (Command)
    if (info.docs) it.command = 'guide_docs'
    else if (info.record) it.command = 'guide_open'
    else if (info.playable) it.command = 'guide_play'
    else if (STEP_KINDS.has(info.kind) || info.missing) it.disabled = true   // шаг без перехода (не играбелен, не запись) / ссылка на отсутствующую запись — приглушён
    // IE 2026 09 28 / ODOO-342342 (приёмка Н2): в карточке пути шаг, которого в демо не показать (Planned / Idea, без якоря), приглушён и тогда, когда он
    // ссылка на кейс (карточка кейса открывается по-прежнему); путь стартует с первого показываемого шага (guidePath_startIndex)
    if (ctx.cardKind === 'path' && info.n != null && !info.playable) it['cssClass-row'] = 'ucm-step-dim'
    const kids = Array.isArray(r?.attrs) ? r.attrs.filter(isObj).map(k => useCaseMenu_item(k, ctx, depthPath.concat(info.id))) : []
    if (kids.length) it.attrs = kids
    return it
}

const groupRow = (r) => isObj(r) && GROUP_KINDS.has(ucRow_kind(r))

// раскладка: группы-этапы / группы-разделы (с собственными пунктами) — колонками, вложенные группы — следом в порядке дерева (одноимённая —
// с именем родителя, как tasksPanel_flatten); прочие строки верхнего уровня — пунктами вне групп (MenuPanel собирает их в группу runsTitle)
export function useCaseMenu_flatten(rows, ctx0 = {}) {
    const t0 = guideCases_now()
    const ctx = ctx0.cardKind === 'case' ? { ...ctx0, _caseLinks: useCaseMenu_caseLinks(rows) } : ctx0
    const out = [], seen = new Set()
    const walk = (list, parentTitle) => {
        for (const r of list || []) {
            if (!isObj(r)) continue
            if (!groupRow(r)) { out.push(useCaseMenu_item(r, ctx)); continue }
            const info = ucRow_info(r, ctx)
            const own = (r.attrs || []).filter(k => isObj(k) && !groupRow(k))
            const title0 = isObj(r.node) ? str(r.node.valueStr) : ''   // пустой заголовок — группа без заголовка (кейсы раздела вне подразделов), id подписью не ставим
            if (own.length || info.kind === 'section') {
                const title = seen.has(title0) && parentTitle ? parentTitle + ' · ' + title0 : title0
                seen.add(title0)
                const g = { title, cssClass: withPi(r?.node?.pi) || KIND_ICON[info.kind], _uc: info, _row: r, attrs: own.map(k => useCaseMenu_item(k, ctx)) }
                if (info.kind === 'section' && info.id) g.command = 'guide_open'   // заголовок раздела — ссылка на его карточку
                const min = ucRow_minutes(r); if (min != null) g.aside = useCaseMenu_minutesText(min, ctx.t)
                if (g.attrs.length) out.push(g)
            }
            walk((r.attrs || []).filter(groupRow), title0)
        }
    }
    walk(rows, '')
    guideCases_count('menu', guideCases_now() - t0)
    return out
}

// что делает клик по пункту: open — карточка записи; play — «Open in demo» строки; docs — читалка; null — ничего
export function useCaseMenu_action(raw) {
    const u = raw && raw._uc
    if (!u) return null
    if (u.docs) return { type: 'docs', link: u.docs }
    if (u.record) return { type: 'open', id: u.id, kind: u.kind }
    if (u.playable) return { type: 'play', params: useCaseMenu_playParams(u) }
    return null
}

// параметры play_plan для строки (контракт §6.1: id?: кейс | путь | якорь-строка, step?: шаг пути, anchor?: id TEST-DATA):
//   кейс / путь — {id};  шаг пути (строка с номером в карточке пути) — {id: путь, step: n};  якорь в карточке кейса — {id: кейс, anchor};
//   прочий играбельный лист (страница / виджет в карточке кейса) — {id: id строки} («якорь-строка» контракта)
export function useCaseMenu_playParams(u) {
    if (!u) return null
    // IE 2026 09 28 / ODOO-342342 (ревью З2): шаг-кейс в карточке пути — шаг ПУТИ (полоса пути с этого шага), не отдельный кейс
    if (u.card && u.card.kind === 'path' && u.card.id && u.n != null) return { id: u.card.id, step: u.n }
    if (u.kind === 'case' || u.kind === 'path') return { id: u.id }
    if (u.kind === 'anchor' && u.card && u.card.id) return { id: u.card.id, anchor: u.anchor || u.id }
    // страница / виджет в карточке кейса — план самого кейса (бэк откроет именно её, см. ucRow_info); id строки бэк как кейс не найдёт
    if (u.card && u.card.id) return { id: u.card.id }
    return { id: u.id }
}

// обход строк
export function useCaseMenu_walk(rows, fn) {
    const rec = (list, depth) => { for (const r of list || []) { if (!isObj(r)) continue; fn(r, depth); rec(r.attrs, depth + 1) } }
    rec(rows, 0)
}

// id записей-кейсов / путей в строках (для get_personal ids — просмотры)
export function useCaseMenu_recordIds(rows) {
    const ids = []
    useCaseMenu_walk(rows, (r) => { const k = ucRow_kind(r), id = ucRow_id(r); if (RECORD_KINDS.has(k) && k !== 'section' && id && !ids.includes(id)) ids.push(id) })
    return ids
}

// итог по строкам: кейсов (уникальных), пройдено (isDone(id)), минут (сумма у листьев с номером или у кейсов), играбельных, «скоро», с провалом проверки
export function useCaseMenu_summary(rows, isDone = () => false) {
    const cases = new Set(), done = new Set()
    let minutes = 0, playable = 0, soon = 0, failed = 0
    useCaseMenu_walk(rows, (r) => {
        const k = ucRow_kind(r), id = ucRow_id(r)
        if (k === 'case' && id) { cases.add(id); let d = false; try { d = !!isDone(id, r) } catch (e) { d = false } if (d) done.add(id) }
        if (STEP_KINDS.has(k) && (r.n != null || k === 'case')) minutes += ucRow_minutes(r) || 0
        if (r.playable && !r.soon) playable++
        if (r.soon) soon++
        if (str(r.check_status) === CHECK_FAILED) failed++
    })
    return { cases: cases.size, done: done.size, minutes: Math.round(minutes * 10) / 10, playable, soon, failed }
}

export default { useCaseMenu_caseLinks, ucRow_unitBadge, ucRow_id, ucRow_kind, ucRow_docsLink, ucRow_minutes, ucRow_status, ucRow_checkBadge, ucRow_info, useCaseMenu_item, useCaseMenu_flatten, useCaseMenu_action, useCaseMenu_playParams, useCaseMenu_walk, useCaseMenu_recordIds, useCaseMenu_summary, useCaseMenu_minutesText }
